<template>
  <div class="cameraDialog">
    <v-dialog v-model="parentDialog" max-width="1000" >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.camera.dialog_header") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-3">
          <v-img :src="camera.url" fluid />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Experiment_APIService } from "@/services/Experiment_APIService";
const apiService = new Experiment_APIService(process.env.VUE_APP_BASE_URL);
export default {
  name: "CameraDialog",
  model: {
    prop: "parentDialog",
    event: "update-parent-dialog",
  },
  props: {
    parentDialog: false,
    camera: {}
  },
  data: function () {
    return {
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update-parent-dialog", false);
      this.camera_dialog = false;
      this.camera = {};
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>